import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  plus310ted5e4i90h as plus,
  sortedWith2csnbbb21k0lg as sortedWith,
  toSet2orjxp16sotqu as toSet,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import {
  LineItemInterface2ct3y0vtnbxod as LineItemInterface,
  Companion_instance357q0zxkn8vu9 as Companion_instance,
  MonetaryValue3pm7jom4inigc as MonetaryValue,
  get_pending3bzoyvzwzq8kn as get_pending,
} from '../../../../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  ChangeRequestItemWrapperlr7b47p0t9ty as ChangeRequestItemWrapper,
  ChangeRequestData3ach2rh1k570 as ChangeRequestData,
  Status_Draft_getInstance6tlwzpe7uax3 as Status_Draft_getInstance,
  Status_PendingApproval_getInstance15f8iecb9d1o9 as Status_PendingApproval_getInstance,
  Status_InReview_getInstance139tuomqphme as Status_InReview_getInstance,
  Status_PartiallyAccepted_getInstancetm1ylzstkb4p as Status_PartiallyAccepted_getInstance,
  Status_Accepted_getInstance2m2t31poyo55g as Status_Accepted_getInstance,
  Status_Rejected_getInstance185k56u04ge1z as Status_Rejected_getInstance,
} from './data.mjs';
import {
  compareBy2697bq0ffft96 as compareBy,
  compareValues1n2ayl87ihzfk as compareValues,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/comparisons/Comparisons.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  Frame1e7t2kcdb3wu7 as Frame,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import {
  get_atTopEnd21ub47e8cwtv6 as get_atTopEnd,
  get_centered1xfu6or5nc0lq as get_centered,
  forEachUpdating2xo34s2yjc7ia as forEachUpdating,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  newChangesAllowed2l43dpoyno2fl as newChangesAllowed,
  isProjectLocked21m24mmy2in1h as isProjectLocked,
} from '../../../../../../../../crowpay-shared/com/crowpay/statePermissions.mjs';
import {
  MemberRole_Manager_getInstance3dbaoot8q9evq as MemberRole_Manager_getInstance,
  ProjectState_Accepted_getInstance2l1kftynf92aa as ProjectState_Accepted_getInstance,
} from '../../../../../../../../crowpay-shared/com/crowpay/enums.mjs';
import { shownWhenxgf1ujy6rmvr as shownWhen } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import {
  get_tertiaryButton1h22y4lorv47t as get_tertiaryButton,
  specCenteredText33v0vmsdeuehr as specCenteredText,
  specCenteredText1zemopd0g3rsf as specCenteredText_0,
} from '../../../../theming/buttons.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import {
  get_viewIsWide3s4g60a9e0192 as get_viewIsWide,
  get_viewIsNarrow26l63sh4olw2h as get_viewIsNarrow,
} from '../../../nav/crowpay.mjs';
import { ProjectLens_Contractor_getInstance3hm6gxlnsv3ks as ProjectLens_Contractor_getInstance } from '../../../../screens/common/ProjectView.mjs';
import {
  get_rem2p56fiaxda5jo as get_rem,
  get_px8ok5q0jdway2 as get_px,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import {
  sizeConstraints2hv7x4j4qpd36 as sizeConstraints,
  get_unpadded3gipn3ftxgnwh as get_unpadded,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { NothingHereSemantic_getInstance3tro8v94k1jgs as NothingHereSemantic_getInstance } from '../../../../theming/appTheme.mjs';
import {
  title1nssp3ryhwuqj as title,
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
  SubtitleSemantic_getInstance37873sehsd699 as SubtitleSemantic_getInstance,
  body3i5t0n7zprpqb as body,
} from '../../../../theming/Titles.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import {
  Align_Center_getInstance2f7zhxjck1drv as Align_Center_getInstance,
  Dimensions32ju1l7z4mh as Dimension,
  divkhq3vjih9fcw as div,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../../../nav/AppDimensions.mjs';
import { ListSemantic_getInstance1hx6c2zatma42 as ListSemantic_getInstance } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { changeOrderCard100xlamk023hn as changeOrderCard } from './mobile/changeOrderCards.mjs';
import { subTitleLabel2tm7wvwblxr1h as subTitleLabel } from '../../../label2.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  Indent_Section_getInstance2f8fy630t595n as Indent_Section_getInstance,
  indented3383b46h9g40w as indented,
} from '../../../space.mjs';
import { Companion_getInstance2xbytizsyx2ps as Companion_getInstance } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/ViewWrapper.mjs';
import { renderDraftChangeOrder2act0apujnstk as renderDraftChangeOrder } from './tables/draftChangeOrder.mjs';
import {
  renderPendingItemsjuqdkw9jhpkp as renderPendingItems,
  renderPendingChangeOrderafxvzeril7s1 as renderPendingChangeOrder,
} from './tables/pendingChangeOrder.mjs';
import { plus1ogy4liedzq5j as plus_0 } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Sets.mjs';
import { lensFilter5xvs6ea8thrl as lensFilter } from '../../../../../utils/utils.mjs';
import { renderReviewedChangeOrderqup1a1u5klok as renderReviewedChangeOrder } from './tables/reviewedChangeOrder.mjs';
import { listOf1jh22dvmctj1r as listOf } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { lens27v59dqa1oc3r as lens } from '../../../../../../../../reactive/com/lightningkite/reactive/lensing/abstracts.mjs';
import {
  toDouble1kn912gjoizjp as toDouble,
  toDoubleOrNullkxwozihadygj as toDoubleOrNull,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/text/numberConversions.mjs';
import { toggle2o6h9frvgo8sq as toggle } from '../../../../../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { get_session9cytjmfbg8nd as get_session } from '../../../../../sdk/UserSession.mjs';
import { await1kke5zj2piplv as await_0 } from '../../../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { ChangeRequesthd3ysa2j1i4f as ChangeRequest } from '../../../../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual1whp5jyfp32aq as serializerOrContextual } from '../../../../../../../../lightning-server-shared/com/lightningkite/serialization/SerializationHelpers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { DataClassPathSelf9694s3fei65z as DataClassPathSelf } from '../../../../../../../../lightning-server-shared/com/lightningkite/serialization/DataClassPath.mjs';
import { get_projectgtrfvpc0zfzj as get_project } from '../../../../../../../../crowpay-shared/com/crowpay/ChangeRequestFields.mjs';
import { eq1298m2cje971u as eq } from '../../../../../../../../lightning-server-shared/com/lightningkite/lightningdb/ConditionBuilder.mjs';
import { get_mainPageNavigator29w1pddlp5wea as get_mainPageNavigator } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Navigator.mjs';
import { ChangeOrderForm23hgjlgmtvjevd as ChangeOrderForm2 } from './ChangeOrderForm2.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { Comparator2b3maoeh98xtg as Comparator } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/ComparatorJs.mjs';
import { setOf45ia9pnfhe90 as setOf } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function getChangeRequestItems(_this__u8e3s4, data, changeOrder, additionalConstraints) {
  var tmp;
  if (additionalConstraints === VOID) {
    tmp = getChangeRequestItems$lambda;
  } else {
    tmp = additionalConstraints;
  }
  additionalConstraints = tmp;
  var adjusted = _this__u8e3s4.daj(data.vgm());
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = _this__u8e3s4.daj(data.kgt());
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList().w();
  var _iterator__ex2g4s = tmp0.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    if (element.c72_1.equals(changeOrder.o57_1) && additionalConstraints(element)) {
      destination.v(element);
    }
  }
  var groupedPendingItems = destination;
  // Inline function 'kotlin.collections.filter' call
  var tmp0_0 = _this__u8e3s4.daj(data.lgt());
  // Inline function 'kotlin.collections.filterTo' call
  var destination_0 = ArrayList().w();
  var _iterator__ex2g4s_0 = tmp0_0.m1();
  while (_iterator__ex2g4s_0.n1()) {
    var element_0 = _iterator__ex2g4s_0.o1();
    if (element_0.v75_1.equals(changeOrder.o57_1) && additionalConstraints(element_0)) {
      destination_0.v(element_0);
    }
  }
  var groupedPendingLines = destination_0;
  // Inline function 'kotlin.collections.map' call
  var this_0 = plus(groupedPendingLines, groupedPendingItems);
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList().u(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s_1 = this_0.m1();
  while (_iterator__ex2g4s_1.n1()) {
    var item = _iterator__ex2g4s_1.o1();
    var tmp_0;
    if (isInterface(item, LineItemInterface())) {
      tmp_0 = item;
    } else {
      // Inline function 'kotlin.collections.find' call
      var tmp$ret$7;
      $l$block: {
        // Inline function 'kotlin.collections.firstOrNull' call
        var _iterator__ex2g4s_2 = adjusted.m1();
        while (_iterator__ex2g4s_2.n1()) {
          var element_1 = _iterator__ex2g4s_2.o1();
          if (element_1.mf9_1.equals(item.t94())) {
            tmp$ret$7 = element_1;
            break $l$block;
          }
        }
        tmp$ret$7 = null;
      }
      var tmp0_safe_receiver = tmp$ret$7;
      tmp_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.kf9_1;
    }
    var infoSource = tmp_0;
    var tmp2_elvis_lhs = infoSource == null ? null : infoSource.i20();
    var tmp_1 = tmp2_elvis_lhs == null ? 'Not Found' : tmp2_elvis_lhs;
    var tmp_2;
    if (isInterface(item, LineItemInterface())) {
      tmp_2 = Companion_instance.r91(0n);
    } else {
      var tmp4_elvis_lhs = infoSource == null ? null : infoSource.x91();
      var tmp_3;
      var tmp_4 = tmp4_elvis_lhs;
      if ((tmp_4 == null ? null : new (MonetaryValue())(tmp_4)) == null) {
        tmp_3 = Companion_instance.m62(-1);
      } else {
        tmp_3 = tmp4_elvis_lhs;
      }
      tmp_2 = tmp_3;
    }
    var tmp$ret$9 = new (ChangeRequestItemWrapper())(item, tmp_1, tmp_2);
    destination_1.v(tmp$ret$9);
  }
  var tmp_5 = destination_1;
  var tmp_6 = getChangeRequestItems$lambda_0;
  return sortedWith(tmp_5, compareBy([tmp_6, getChangeRequestItems$lambda_1]));
}
function getChangeRequestItems_0(_this__u8e3s4, changeOrder, additionalConstraints) {
  var tmp;
  if (additionalConstraints === VOID) {
    tmp = getChangeRequestItems$lambda_2;
  } else {
    tmp = additionalConstraints;
  }
  additionalConstraints = tmp;
  return remember(VOID, VOID, VOID, ($this$remember) => getChangeRequestItems($this$remember, _this__u8e3s4, $this$remember.daj(changeOrder), additionalConstraints));
}
function projectChangeOrders(_this__u8e3s4, writer) {
  // Inline function 'kotlin.with' call
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(writer.pc());
  var tmp0_elvis_lhs = writer.ebb_1;
  var p = tmp0_elvis_lhs == null ? writer : tmp0_elvis_lhs;
  writer.gbb(p, view);
  view.zbm(true);
  var voiding = Signal().hak(false);
  if (_this__u8e3s4.tgj().equals(ProjectLens_Contractor_getInstance())) {
    var tmp = get_atTopEnd(view);
    var tmp_0 = view.kbb(tmp, shownWhen(view, VOID, ($this$shownWhen) => {
      var s = $this$shownWhen.daj(_this__u8e3s4.lfy()).u7b_1;
      var tmp0_elvis_lhs = $this$shownWhen.daj(_this__u8e3s4.rgj_1);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        return false;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var role = tmp;
      return newChangesAllowed(s) && role.d4(MemberRole_Manager_getInstance()) >= 0;
    }));
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_0 = new (RowOrCol())(view.pc());
    var tmp0_elvis_lhs_0 = view.ebb_1;
    var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
    view.gbb(p_0, view_0);
    view_0.zbm(false);
    if (get_viewIsWide(view_0)) {
      var tmp_1 = view_0.kbb(shownWhen(view_0, VOID, ($this$shownWhen) => {
        var tmp0 = $this$shownWhen.daj(_this__u8e3s4.xgv());
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'kotlin.collections.any' call
          var tmp;
          if (isInterface(tmp0, Collection())) {
            tmp = tmp0.i1();
          } else {
            tmp = false;
          }
          if (tmp) {
            tmp$ret$0 = false;
            break $l$block_0;
          }
          var _iterator__ex2g4s = tmp0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            if (element.y57_1 > 0) {
              tmp$ret$0 = true;
              break $l$block_0;
            }
          }
          tmp$ret$0 = false;
        }
        return tmp$ret$0;
      }), get_tertiaryButton(view_0));
      // Inline function 'com.lightningkite.kiteui.views.direct.button' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_1 = new (Button())(view_0.pc());
      var tmp0_elvis_lhs_1 = view_0.ebb_1;
      var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
      view_0.gbb(p_1, view_1);
      var tmp_2 = KMutableProperty0();
      var tmp_3 = Button$_get_enabled_$ref_61t7nx(view_1);
      // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
      var this_0 = getPropertyCallableRef('enabled', 0, tmp_2, tmp_3, Button$_set_enabled_$ref_o8kynz(view_1));
      reactiveScope(view_1, ($this$reactiveScope) => {
        var tmp$ret$2 = !isProjectLocked($this$reactiveScope.daj(_this__u8e3s4.lfy()).u7b_1);
        this_0.set(tmp$ret$2);
        return Unit_instance;
      });
      specCenteredText(view_1, ($this$specCenteredText) => $this$specCenteredText.daj(voiding) ? 'Cancel Voiding' : 'Void Items');
      onClick(view_1, VOID, VOID, projectChangeOrders$slambda_0(voiding));
      view_0.hbb(p_1, view_1);
      view_0.lbb(tmp_1, view_1);
    }
    var tmp_4 = get_tertiaryButton(view_0);
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_2 = new (Button())(view_0.pc());
    var tmp0_elvis_lhs_2 = view_0.ebb_1;
    var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
    view_0.gbb(p_2, view_2);
    var tmp_5 = KMutableProperty0();
    var tmp_6 = Button$_get_enabled_$ref_61t7nx_0(view_2);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_1 = getPropertyCallableRef('enabled', 0, tmp_5, tmp_6, Button$_set_enabled_$ref_o8kynz_0(view_2));
    reactiveScope(view_2, ($this$reactiveScope) => {
      var tmp$ret$7 = !isProjectLocked($this$reactiveScope.daj(_this__u8e3s4.lfy()).u7b_1);
      this_1.set(tmp$ret$7);
      return Unit_instance;
    });
    specCenteredText_0(view_2, '+ Change Order');
    onClick(view_2, 'Create New Change Order', VOID, projectChangeOrders$slambda_2(_this__u8e3s4, view_2));
    view_0.hbb(p_2, view_2);
    view_0.lbb(tmp_4, view_2);
    view.hbb(p_0, view_0);
    view.lbb(tmp_0, view_0);
  }
  var tmp_7 = sizeConstraints(view, VOID, VOID, VOID, VOID, VOID, VOID, get_rem(15));
  var tmp_8 = view.kbb(tmp_7, shownWhen(view, VOID, ($this$shownWhen) => {
    var tmp;
    if (_this__u8e3s4.tgj().zgj()) {
      // Inline function 'kotlin.let' call
      var it = $this$shownWhen.daj(_this__u8e3s4.xgv());
      var tmp_0;
      if (it.i1()) {
        tmp_0 = true;
      } else {
        var tmp$ret$16;
        $l$block_2: {
          // Inline function 'kotlin.collections.all' call
          var tmp_1;
          if (isInterface(it, Collection())) {
            tmp_1 = it.i1();
          } else {
            tmp_1 = false;
          }
          if (tmp_1) {
            tmp$ret$16 = true;
            break $l$block_2;
          }
          var _iterator__ex2g4s = it.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            if (!(element.t57_1 == null)) {
              tmp$ret$16 = false;
              break $l$block_2;
            }
          }
          tmp$ret$16 = true;
        }
        tmp_0 = tmp$ret$16;
      }
      tmp = tmp_0;
    } else {
      tmp = $this$shownWhen.daj(_this__u8e3s4.xgv()).i1();
    }
    return tmp;
  }));
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (Frame())(view.pc());
  var tmp0_elvis_lhs_3 = view.ebb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view : tmp0_elvis_lhs_3;
  view.gbb(p_3, view_3);
  var tmp_9 = view_3.kbb(get_centered(view_3), view_3.jbb(NothingHereSemantic_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_4 = new (RowOrCol())(view_3.pc());
  var tmp0_elvis_lhs_4 = view_3.ebb_1;
  var p_4 = tmp0_elvis_lhs_4 == null ? view_3 : tmp0_elvis_lhs_4;
  view_3.gbb(p_4, view_4);
  view_4.zbm(true);
  view_4.lbb(get_centered(view_4), title(view_4, 'Nothing Yet'));
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_5 = new (TextView())(view_4.pc());
  var tmp0_elvis_lhs_5 = view_4.ebb_1;
  var p_5 = tmp0_elvis_lhs_5 == null ? view_4 : tmp0_elvis_lhs_5;
  view_4.gbb(p_5, view_5);
  view_5.lba(view_5.qb6_1.abf(BodySemantic_getInstance()));
  view_5.dbs(Align_Center_getInstance());
  var tmp_10 = KMutableProperty0();
  var tmp_11 = TextView$_get_content_$ref_4pzcwl(view_5);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_2 = getPropertyCallableRef('content', 0, tmp_10, tmp_11, TextView$_set_content_$ref_pketfb(view_5));
  reactiveScope(view_5, ($this$reactiveScope) => {
    var tmp$ret$20 = $this$reactiveScope.daj(_this__u8e3s4.cgj_1).d4(ProjectState_Accepted_getInstance()) < 0 ? 'This info will be available once the project is Awarded or In Progress.' : _this__u8e3s4.tgj().zgj() ? 'When changes to project scope are proposed or accepted they will appear here.' : 'When changes to project scope are proposed or accepted they will appear here.\nPress "+ Change Order" to create and propose a new change.';
    this_2.set(tmp$ret$20);
    return Unit_instance;
  });
  view_4.hbb(p_5, view_5);
  view_3.hbb(p_4, view_4);
  view_3.lbb(tmp_9, view_4);
  view.hbb(p_3, view_3);
  view.lbb(tmp_8, view_3);
  if (get_viewIsNarrow(view))
    changeOrderCards(_this__u8e3s4, view);
  else
    changeOrderTables(_this__u8e3s4, view, voiding);
  writer.hbb(p, view);
  return view;
}
function changeOrderCards(_this__u8e3s4, writer) {
  // Inline function 'kotlin.with' call
  var data = remember(VOID, VOID, VOID, ($this$remember) => {
    // Inline function 'kotlin.collections.sortedBy' call
    var this_0 = $this$remember.daj(_this__u8e3s4.xgv());
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp = changeOrderCards$lambda$lambda;
    var tmp$ret$0 = new (sam$kotlin_Comparator$0())(tmp);
    // Inline function 'kotlin.collections.map' call
    var this_1 = sortedWith(this_0, tmp$ret$0);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList().u(collectionSizeOrDefault(this_1, 10));
    var _iterator__ex2g4s = this_1.m1();
    while (_iterator__ex2g4s.n1()) {
      var item = _iterator__ex2g4s.o1();
      var tmp$ret$2 = new (ChangeRequestData())(item, getChangeRequestItems($this$remember, _this__u8e3s4, item));
      destination.v(tmp$ret$2);
    }
    return destination;
  });
  var drafts = changeOrderCards$_anonymous_$lensFilter_x2p6s4(data, changeOrderCards$lambda);
  var pending = changeOrderCards$_anonymous_$lensFilter_x2p6s4(data, changeOrderCards$lambda_0);
  var reviewed = changeOrderCards$_anonymous_$lensFilter_x2p6s4(data, changeOrderCards$lambda_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(writer.pc());
  var tmp0_elvis_lhs = writer.ebb_1;
  var p = tmp0_elvis_lhs == null ? writer : tmp0_elvis_lhs;
  writer.gbb(p, view);
  view.zbm(true);
  view.bb9(get_AppDimensions().bg2_1);
  if (_this__u8e3s4.tgj().equals(ProjectLens_Contractor_getInstance())) {
    var tmp = shownWhen(view, VOID, ($this$shownWhen) => {
      var tmp0_elvis_lhs = $this$shownWhen.daj(_this__u8e3s4.rgj_1);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        return false;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var myRole = tmp;
      var tmp_0;
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!$this$shownWhen.daj(drafts).i1()) {
        tmp_0 = myRole.d4(MemberRole_Manager_getInstance()) >= 0;
      } else {
        tmp_0 = false;
      }
      return tmp_0;
    });
    view.lbb(tmp, subTitleLabel(view, 'Draft Changes', ($this$subTitleLabel) => {
      var tmp = $this$subTitleLabel.jbb(ListSemantic_getInstance());
      // Inline function 'com.lightningkite.kiteui.views.direct.col' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view = new (RowOrCol())($this$subTitleLabel.pc());
      var tmp0_elvis_lhs = $this$subTitleLabel.ebb_1;
      var p = tmp0_elvis_lhs == null ? $this$subTitleLabel : tmp0_elvis_lhs;
      $this$subTitleLabel.gbb(p, view);
      view.zbm(true);
      forEachUpdating(view, drafts, VOID, ($this$forEachUpdating, it) => {
        changeOrderCard(_this__u8e3s4, it, $this$forEachUpdating);
        return Unit_instance;
      });
      $this$subTitleLabel.hbb(p, view);
      return $this$subTitleLabel.lbb(tmp, view);
    }));
  }
  var tmp_0 = shownWhen(view, true, ($this$shownWhen) => {
    // Inline function 'kotlin.collections.isNotEmpty' call
    return !$this$shownWhen.daj(pending).i1();
  });
  view.lbb(tmp_0, subTitleLabel(view, 'Pending Changes', ($this$subTitleLabel) => {
    var tmp = $this$subTitleLabel.jbb(ListSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (RowOrCol())($this$subTitleLabel.pc());
    var tmp0_elvis_lhs = $this$subTitleLabel.ebb_1;
    var p = tmp0_elvis_lhs == null ? $this$subTitleLabel : tmp0_elvis_lhs;
    $this$subTitleLabel.gbb(p, view);
    view.zbm(true);
    forEachUpdating(view, pending, VOID, ($this$forEachUpdating, it) => {
      changeOrderCard(_this__u8e3s4, it, $this$forEachUpdating);
      return Unit_instance;
    });
    $this$subTitleLabel.hbb(p, view);
    return $this$subTitleLabel.lbb(tmp, view);
  }));
  var tmp_1 = shownWhen(view, true, ($this$shownWhen) => {
    // Inline function 'kotlin.collections.isNotEmpty' call
    return !$this$shownWhen.daj(reviewed).i1();
  });
  view.lbb(tmp_1, subTitleLabel(view, 'Scope Changes', ($this$subTitleLabel) => {
    var tmp = $this$subTitleLabel.jbb(ListSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (RowOrCol())($this$subTitleLabel.pc());
    var tmp0_elvis_lhs = $this$subTitleLabel.ebb_1;
    var p = tmp0_elvis_lhs == null ? $this$subTitleLabel : tmp0_elvis_lhs;
    $this$subTitleLabel.gbb(p, view);
    view.zbm(true);
    forEachUpdating(view, reviewed, VOID, ($this$forEachUpdating, it) => {
      changeOrderCard(_this__u8e3s4, it, $this$forEachUpdating);
      return Unit_instance;
    });
    $this$subTitleLabel.hbb(p, view);
    return $this$subTitleLabel.lbb(tmp, view);
  }));
  writer.hbb(p, view);
  return view;
}
function changeOrderTables(_this__u8e3s4, writer, voiding) {
  // Inline function 'kotlin.with' call
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(writer.pc());
  var tmp0_elvis_lhs = writer.ebb_1;
  var p = tmp0_elvis_lhs == null ? writer : tmp0_elvis_lhs;
  writer.gbb(p, view);
  view.zbm(true);
  view.bb9(get_AppDimensions().bg2_1);
  if (_this__u8e3s4.tgj().equals(ProjectLens_Contractor_getInstance())) {
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_0 = new (RowOrCol())(view.pc());
    var tmp0_elvis_lhs_0 = view.ebb_1;
    var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
    view.gbb(p_0, view_0);
    view_0.zbm(true);
    var draftChangeOrders = remember(VOID, VOID, VOID, ($this$remember) => {
      // Inline function 'kotlin.collections.filter' call
      var tmp0 = $this$remember.daj(_this__u8e3s4.xgv());
      // Inline function 'kotlin.collections.filterTo' call
      var destination = ArrayList().w();
      var _iterator__ex2g4s = tmp0.m1();
      while (_iterator__ex2g4s.n1()) {
        var element = _iterator__ex2g4s.o1();
        if (element.t57_1 == null) {
          destination.v(element);
        }
      }
      return destination;
    });
    var tmp = KMutableProperty0();
    var tmp_0 = RowOrCol$_get_shown_$ref_m8lfse(view_0);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_0 = getPropertyCallableRef('shown', 0, tmp, tmp_0, RowOrCol$_set_shown_$ref_7290m6(view_0));
    reactiveScope(view_0, ($this$reactiveScope) => {
      var tmp$ret$3;
      $l$block: {
        var tmp0_elvis_lhs = $this$reactiveScope.daj(_this__u8e3s4.rgj_1);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          tmp$ret$3 = false;
          break $l$block;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var myRole = tmp;
        var tmp_0;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!$this$reactiveScope.daj(draftChangeOrders).i1()) {
          tmp_0 = myRole.d4(MemberRole_Manager_getInstance()) >= 0;
        } else {
          tmp_0 = false;
        }
        tmp$ret$3 = tmp_0;
      }
      this_0.set(tmp$ret$3);
      return Unit_instance;
    });
    // Inline function 'com.crowpay.views.theming.subTitle' call
    var content = 'Draft Changes';
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_1 = new (TextView())(view_0.pc());
    var tmp0_elvis_lhs_1 = view_0.ebb_1;
    var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
    view_0.gbb(p_1, view_1);
    view_1.lba(view_1.qb6_1.abf(SubtitleSemantic_getInstance()));
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp_1 = view_1.vb5_1;
    var tmp_2;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(content) === 0) {
      tmp_2 = '\xA0';
    } else {
      tmp_2 = content;
    }
    tmp_1.hbu(tmp_2);
    view_0.hbb(p_1, view_1);
    // Inline function 'com.crowpay.views.components.sectionIndentCol' call
    // Inline function 'com.crowpay.views.components.indentedCol' call
    var indent = Indent_Section_getInstance();
    var tmp2 = indent.agr_1;
    // Inline function 'com.crowpay.views.components.indentedCol' call
    var afterSpace = indent.bgr_1;
    var tmp_3 = get_unpadded(view_0);
    // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_2 = new (Frame())(view_0.pc());
    var tmp0_elvis_lhs_2 = view_0.ebb_1;
    var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
    view_0.gbb(p_2, view_2);
    var tmp_4;
    var tmp_5 = null;
    if (!((tmp_5 == null ? null : new (Dimension())(tmp_5)) == null)) {
      tmp_4 = sizeConstraints(view_2, VOID, VOID, VOID, VOID, VOID, null);
    } else {
      tmp_4 = Companion_getInstance();
    }
    var tmp_6 = view_2.kbb(tmp_4, indented(view_2, tmp2, afterSpace));
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_3 = new (RowOrCol())(view_2.pc());
    var tmp0_elvis_lhs_3 = view_2.ebb_1;
    var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
    view_2.gbb(p_3, view_3);
    view_3.zbm(true);
    view_3.bb9(get_px(0));
    forEachUpdating(view_3, draftChangeOrders, VOID, ($this$forEachUpdating, draft) => {
      renderDraftChangeOrder($this$forEachUpdating, draft, getChangeRequestItems_0(_this__u8e3s4, draft));
      return Unit_instance;
    });
    view_2.hbb(p_3, view_3);
    view_2.lbb(tmp_6, view_3);
    view_0.hbb(p_2, view_2);
    view_0.lbb(tmp_3, view_2);
    view.hbb(p_0, view_0);
  }
  var pendingChangeOrders = remember(VOID, VOID, VOID, ($this$remember) => {
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = $this$remember.daj(_this__u8e3s4.xgv());
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList().w();
    var _iterator__ex2g4s = tmp0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      if (element.y57_1 > 0) {
        destination.v(element);
      }
    }
    return destination;
  });
  var tmp_7 = shownWhen(view, VOID, ($this$shownWhen) => {
    // Inline function 'kotlin.collections.isNotEmpty' call
    return !$this$shownWhen.daj(pendingChangeOrders).i1();
  });
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_4 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_4 = view.ebb_1;
  var p_4 = tmp0_elvis_lhs_4 == null ? view : tmp0_elvis_lhs_4;
  view.gbb(p_4, view_4);
  view_4.zbm(true);
  // Inline function 'com.crowpay.views.theming.subTitle' call
  var content_0 = 'Pending Changes';
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_5 = new (TextView())(view_4.pc());
  var tmp0_elvis_lhs_5 = view_4.ebb_1;
  var p_5 = tmp0_elvis_lhs_5 == null ? view_4 : tmp0_elvis_lhs_5;
  view_4.gbb(p_5, view_5);
  view_5.lba(view_5.qb6_1.abf(SubtitleSemantic_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var tmp_8 = view_5.vb5_1;
  var tmp_9;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(content_0) === 0) {
    tmp_9 = '\xA0';
  } else {
    tmp_9 = content_0;
  }
  tmp_8.hbu(tmp_9);
  view_4.hbb(p_5, view_5);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_6 = new (RowOrCol())(view_4.pc());
  var tmp0_elvis_lhs_6 = view_4.ebb_1;
  var p_6 = tmp0_elvis_lhs_6 == null ? view_4 : tmp0_elvis_lhs_6;
  view_4.gbb(p_6, view_6);
  view_6.zbm(true);
  var pendingItems = remember(VOID, VOID, VOID, ($this$remember) => {
    var adjusted = $this$remember.daj(_this__u8e3s4.vgm());
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = $this$remember.daj(_this__u8e3s4.xgv());
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList().w();
    var _iterator__ex2g4s = tmp0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      if (!(element.t57_1 == null) && !element.u57_1) {
        destination.v(element);
      }
    }
    var nonCardinal = destination;
    // Inline function 'kotlin.collections.filter' call
    var tmp0_0 = $this$remember.daj(_this__u8e3s4.kgt());
    // Inline function 'kotlin.collections.filterTo' call
    var destination_0 = ArrayList().w();
    var _iterator__ex2g4s_0 = tmp0_0.m1();
    while (_iterator__ex2g4s_0.n1()) {
      var element_0 = _iterator__ex2g4s_0.o1();
      if (get_pending(element_0)) {
        destination_0.v(element_0);
      }
    }
    var pendingChanges = destination_0;
    // Inline function 'kotlin.collections.filter' call
    var tmp0_1 = $this$remember.daj(_this__u8e3s4.lgt());
    // Inline function 'kotlin.collections.filterTo' call
    var destination_1 = ArrayList().w();
    var _iterator__ex2g4s_1 = tmp0_1.m1();
    while (_iterator__ex2g4s_1.n1()) {
      var element_1 = _iterator__ex2g4s_1.o1();
      if (get_pending(element_1)) {
        destination_1.v(element_1);
      }
    }
    var pendingNewLineItems = destination_1;
    // Inline function 'kotlin.collections.mapNotNull' call
    var tmp0_2 = plus(pendingChanges, pendingNewLineItems);
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination_2 = ArrayList().w();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_2 = tmp0_2.m1();
    while (_iterator__ex2g4s_2.n1()) {
      var element_2 = _iterator__ex2g4s_2.o1();
      // Inline function 'kotlin.collections.find' call
      var tmp$ret$46;
      $l$block_0: {
        // Inline function 'kotlin.collections.firstOrNull' call
        var _iterator__ex2g4s_3 = nonCardinal.m1();
        while (_iterator__ex2g4s_3.n1()) {
          var element_3 = _iterator__ex2g4s_3.o1();
          if (element_3.o57_1.equals(element_2.s94())) {
            tmp$ret$46 = element_3;
            break $l$block_0;
          }
        }
        tmp$ret$46 = null;
      }
      var tmp;
      if (tmp$ret$46 == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.let' call
        var tmp_0;
        if (isInterface(element_2, LineItemInterface())) {
          tmp_0 = element_2;
        } else {
          // Inline function 'kotlin.collections.find' call
          var tmp$ret$49;
          $l$block_1: {
            // Inline function 'kotlin.collections.firstOrNull' call
            var _iterator__ex2g4s_4 = adjusted.m1();
            while (_iterator__ex2g4s_4.n1()) {
              var element_4 = _iterator__ex2g4s_4.o1();
              if (element_4.mf9_1.equals(element_2.t94())) {
                tmp$ret$49 = element_4;
                break $l$block_1;
              }
            }
            tmp$ret$49 = null;
          }
          tmp_0 = tmp$ret$49;
        }
        var infoSource = tmp_0;
        var tmp1_elvis_lhs = infoSource == null ? null : infoSource.i20();
        var tmp_1 = tmp1_elvis_lhs == null ? 'Not Found' : tmp1_elvis_lhs;
        var tmp_2;
        if (isInterface(element_2, LineItemInterface())) {
          tmp_2 = Companion_instance.r91(0n);
        } else {
          var tmp3_elvis_lhs = infoSource == null ? null : infoSource.x91();
          var tmp_3;
          var tmp_4 = tmp3_elvis_lhs;
          if ((tmp_4 == null ? null : new (MonetaryValue())(tmp_4)) == null) {
            tmp_3 = Companion_instance.m62(-1);
          } else {
            tmp_3 = tmp3_elvis_lhs;
          }
          tmp_2 = tmp_3;
        }
        tmp = new (ChangeRequestItemWrapper())(element_2, tmp_1, tmp_2);
      }
      var tmp0_safe_receiver = tmp;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        destination_2.v(tmp0_safe_receiver);
      }
    }
    var tmp_5 = destination_2;
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp_6 = changeOrderTables$lambda$lambda;
    // Inline function 'kotlin.comparisons.thenBy' call
    var this_0 = new (sam$kotlin_Comparator$0_0())(tmp_6);
    var tmp_7 = (a, b) => {
      var previousCompare = this_0.compare(a, b);
      var tmp;
      if (!(previousCompare === 0)) {
        tmp = previousCompare;
      } else {
        // Inline function 'kotlin.comparisons.compareValuesBy' call
        var tmp_0 = a.pgp_1;
        var tmp$ret$62 = b.pgp_1;
        tmp = compareValues(tmp_0, tmp$ret$62);
      }
      return tmp;
    };
    var tmp$ret$64 = new (sam$kotlin_Comparator$0_0())(tmp_7);
    return sortedWith(tmp_5, tmp$ret$64);
  });
  var tmp_10 = shownWhen(view_6, VOID, ($this$shownWhen) => {
    // Inline function 'kotlin.collections.isNotEmpty' call
    return !$this$shownWhen.daj(pendingItems).i1();
  });
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_7 = new (Frame())(view_6.pc());
  var tmp0_elvis_lhs_7 = view_6.ebb_1;
  var p_7 = tmp0_elvis_lhs_7 == null ? view_6 : tmp0_elvis_lhs_7;
  view_6.gbb(p_7, view_7);
  renderPendingItems(view_7, _this__u8e3s4.xgv(), pendingItems, voiding, _this__u8e3s4.tgj());
  view_6.hbb(p_7, view_7);
  view_6.lbb(tmp_10, view_7);
  var groups = remember(VOID, VOID, VOID, ($this$remember) => {
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = $this$remember.daj(pendingChangeOrders);
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList().w();
    var _iterator__ex2g4s = tmp0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      if (element.u57_1) {
        destination.v(element);
      }
    }
    return destination;
  });
  var tmp_11 = shownWhen(view_6, VOID, ($this$shownWhen) => {
    // Inline function 'kotlin.collections.isNotEmpty' call
    return !$this$shownWhen.daj(groups).i1();
  });
  // Inline function 'com.crowpay.views.components.sectionIndentCol' call
  // Inline function 'com.crowpay.views.components.indentedCol' call
  var indent_0 = Indent_Section_getInstance();
  var tmp2_0 = indent_0.agr_1;
  // Inline function 'com.crowpay.views.components.indentedCol' call
  var afterSpace_0 = indent_0.bgr_1;
  var tmp_12 = get_unpadded(view_6);
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_8 = new (Frame())(view_6.pc());
  var tmp0_elvis_lhs_8 = view_6.ebb_1;
  var p_8 = tmp0_elvis_lhs_8 == null ? view_6 : tmp0_elvis_lhs_8;
  view_6.gbb(p_8, view_8);
  var tmp_13;
  var tmp_14 = null;
  if (!((tmp_14 == null ? null : new (Dimension())(tmp_14)) == null)) {
    tmp_13 = sizeConstraints(view_8, VOID, VOID, VOID, VOID, VOID, null);
  } else {
    tmp_13 = Companion_getInstance();
  }
  var tmp_15 = view_8.kbb(tmp_13, indented(view_8, tmp2_0, afterSpace_0));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_9 = new (RowOrCol())(view_8.pc());
  var tmp0_elvis_lhs_9 = view_8.ebb_1;
  var p_9 = tmp0_elvis_lhs_9 == null ? view_8 : tmp0_elvis_lhs_9;
  view_8.gbb(p_9, view_9);
  view_9.zbm(true);
  view_9.bb9(div(view_9.mba().jb0_1, 2));
  body(view_9, 'Work Groups');
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_10 = new (RowOrCol())(view_9.pc());
  var tmp0_elvis_lhs_10 = view_9.ebb_1;
  var p_10 = tmp0_elvis_lhs_10 == null ? view_9 : tmp0_elvis_lhs_10;
  view_9.gbb(p_10, view_10);
  view_10.zbm(true);
  view_10.bb9(get_px(0));
  forEachUpdating(view_10, groups, VOID, ($this$forEachUpdating, change) => {
    renderPendingChangeOrder($this$forEachUpdating, change, getChangeRequestItems_0(_this__u8e3s4, change), _this__u8e3s4.tgj());
    return Unit_instance;
  });
  view_9.hbb(p_10, view_10);
  view_8.hbb(p_9, view_9);
  view_8.lbb(tmp_15, view_9);
  view_6.hbb(p_8, view_8);
  var tmp$ret$86 = view_6.lbb(tmp_12, view_8);
  view_6.lbb(tmp_11, tmp$ret$86);
  view_4.hbb(p_6, view_6);
  view.hbb(p_4, view_4);
  view.lbb(tmp_7, view_4);
  var changeOrdersWithReviewedChanges = remember(VOID, VOID, VOID, ($this$remember) => {
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = $this$remember.daj(_this__u8e3s4.kgt());
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList().w();
    var _iterator__ex2g4s = tmp0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      if (!(element.i72_1 == null)) {
        destination.v(element);
      }
    }
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList().u(collectionSizeOrDefault(destination, 10));
    var _iterator__ex2g4s_0 = destination.m1();
    while (_iterator__ex2g4s_0.n1()) {
      var item = _iterator__ex2g4s_0.o1();
      var tmp$ret$98 = item.c72_1;
      destination_0.v(tmp$ret$98);
    }
    var tmp = toSet(destination_0);
    // Inline function 'kotlin.collections.filter' call
    var tmp0_0 = $this$remember.daj(_this__u8e3s4.lgt());
    // Inline function 'kotlin.collections.filterTo' call
    var destination_1 = ArrayList().w();
    var _iterator__ex2g4s_1 = tmp0_0.m1();
    while (_iterator__ex2g4s_1.n1()) {
      var element_0 = _iterator__ex2g4s_1.o1();
      if (!(element_0.e76_1 == null)) {
        destination_1.v(element_0);
      }
    }
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_2 = ArrayList().u(collectionSizeOrDefault(destination_1, 10));
    var _iterator__ex2g4s_2 = destination_1.m1();
    while (_iterator__ex2g4s_2.n1()) {
      var item_0 = _iterator__ex2g4s_2.o1();
      var tmp$ret$104 = item_0.v75_1;
      destination_2.v(tmp$ret$104);
    }
    var reviewedIds = plus_0(tmp, toSet(destination_2));
    // Inline function 'kotlin.collections.filter' call
    var tmp0_1 = $this$remember.daj(_this__u8e3s4.xgv());
    // Inline function 'kotlin.collections.filterTo' call
    var destination_3 = ArrayList().w();
    var _iterator__ex2g4s_3 = tmp0_1.m1();
    while (_iterator__ex2g4s_3.n1()) {
      var element_1 = _iterator__ex2g4s_3.o1();
      if (reviewedIds.t1(element_1.o57_1)) {
        destination_3.v(element_1);
      }
    }
    return destination_3;
  });
  var tmp_16 = shownWhen(view, VOID, ($this$shownWhen) => {
    // Inline function 'kotlin.collections.isNotEmpty' call
    return !$this$shownWhen.daj(changeOrdersWithReviewedChanges).i1();
  });
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_11 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_11 = view.ebb_1;
  var p_11 = tmp0_elvis_lhs_11 == null ? view : tmp0_elvis_lhs_11;
  view.gbb(p_11, view_11);
  view_11.zbm(true);
  // Inline function 'com.crowpay.views.theming.subTitle' call
  var content_1 = 'Scope Changes';
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_12 = new (TextView())(view_11.pc());
  var tmp0_elvis_lhs_12 = view_11.ebb_1;
  var p_12 = tmp0_elvis_lhs_12 == null ? view_11 : tmp0_elvis_lhs_12;
  view_11.gbb(p_12, view_12);
  view_12.lba(view_12.qb6_1.abf(SubtitleSemantic_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var tmp_17 = view_12.vb5_1;
  var tmp_18;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(content_1) === 0) {
    tmp_18 = '\xA0';
  } else {
    tmp_18 = content_1;
  }
  tmp_17.hbu(tmp_18);
  view_11.hbb(p_12, view_12);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_13 = new (RowOrCol())(view_11.pc());
  var tmp0_elvis_lhs_13 = view_11.ebb_1;
  var p_13 = tmp0_elvis_lhs_13 == null ? view_11 : tmp0_elvis_lhs_13;
  view_11.gbb(p_13, view_13);
  view_13.zbm(true);
  view_13.bb9(get_AppDimensions().bg2_1);
  var nonCardinalChanges = lensFilter(changeOrdersWithReviewedChanges, changeOrderTables$lambda);
  var tmp_19 = shownWhen(view_13, VOID, ($this$shownWhen) => {
    // Inline function 'kotlin.collections.isNotEmpty' call
    return !$this$shownWhen.daj(nonCardinalChanges).i1();
  });
  // Inline function 'com.crowpay.views.components.sectionIndentCol' call
  // Inline function 'com.crowpay.views.components.indentedCol' call
  var indent_1 = Indent_Section_getInstance();
  var tmp2_1 = indent_1.agr_1;
  // Inline function 'com.crowpay.views.components.indentedCol' call
  var afterSpace_1 = indent_1.bgr_1;
  var tmp_20 = get_unpadded(view_13);
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_14 = new (Frame())(view_13.pc());
  var tmp0_elvis_lhs_14 = view_13.ebb_1;
  var p_14 = tmp0_elvis_lhs_14 == null ? view_13 : tmp0_elvis_lhs_14;
  view_13.gbb(p_14, view_14);
  var tmp_21;
  var tmp_22 = null;
  if (!((tmp_22 == null ? null : new (Dimension())(tmp_22)) == null)) {
    tmp_21 = sizeConstraints(view_14, VOID, VOID, VOID, VOID, VOID, null);
  } else {
    tmp_21 = Companion_getInstance();
  }
  var tmp_23 = view_14.kbb(tmp_21, indented(view_14, tmp2_1, afterSpace_1));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_15 = new (RowOrCol())(view_14.pc());
  var tmp0_elvis_lhs_15 = view_14.ebb_1;
  var p_15 = tmp0_elvis_lhs_15 == null ? view_14 : tmp0_elvis_lhs_15;
  view_14.gbb(p_15, view_15);
  view_15.zbm(true);
  view_15.bb9(div(view_15.mba().jb0_1, 2));
  body(view_15, 'Work Items');
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_16 = new (RowOrCol())(view_15.pc());
  var tmp0_elvis_lhs_16 = view_15.ebb_1;
  var p_16 = tmp0_elvis_lhs_16 == null ? view_15 : tmp0_elvis_lhs_16;
  view_15.gbb(p_16, view_16);
  view_16.zbm(true);
  view_16.bb9(get_px(0));
  forEachUpdating(view_16, nonCardinalChanges, VOID, ($this$forEachUpdating, change) => {
    renderReviewedChangeOrder(_this__u8e3s4, $this$forEachUpdating, change, getChangeRequestItems_0(_this__u8e3s4, change, changeOrderTables$lambda$lambda_0), false);
    return Unit_instance;
  });
  view_15.hbb(p_16, view_16);
  view_14.hbb(p_15, view_15);
  view_14.lbb(tmp_23, view_15);
  view_13.hbb(p_14, view_14);
  var tmp$ret$131 = view_13.lbb(tmp_20, view_14);
  view_13.lbb(tmp_19, tmp$ret$131);
  var cardinalChanges = lensFilter(changeOrdersWithReviewedChanges, changeOrderTables$lambda_0);
  var tmp_24 = shownWhen(view_13, VOID, ($this$shownWhen) => {
    // Inline function 'kotlin.collections.isNotEmpty' call
    return !$this$shownWhen.daj(cardinalChanges).i1();
  });
  // Inline function 'com.crowpay.views.components.sectionIndentCol' call
  // Inline function 'com.crowpay.views.components.indentedCol' call
  var indent_2 = Indent_Section_getInstance();
  var tmp2_2 = indent_2.agr_1;
  // Inline function 'com.crowpay.views.components.indentedCol' call
  var afterSpace_2 = indent_2.bgr_1;
  var tmp_25 = get_unpadded(view_13);
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_17 = new (Frame())(view_13.pc());
  var tmp0_elvis_lhs_17 = view_13.ebb_1;
  var p_17 = tmp0_elvis_lhs_17 == null ? view_13 : tmp0_elvis_lhs_17;
  view_13.gbb(p_17, view_17);
  var tmp_26;
  var tmp_27 = null;
  if (!((tmp_27 == null ? null : new (Dimension())(tmp_27)) == null)) {
    tmp_26 = sizeConstraints(view_17, VOID, VOID, VOID, VOID, VOID, null);
  } else {
    tmp_26 = Companion_getInstance();
  }
  var tmp_28 = view_17.kbb(tmp_26, indented(view_17, tmp2_2, afterSpace_2));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_18 = new (RowOrCol())(view_17.pc());
  var tmp0_elvis_lhs_18 = view_17.ebb_1;
  var p_18 = tmp0_elvis_lhs_18 == null ? view_17 : tmp0_elvis_lhs_18;
  view_17.gbb(p_18, view_18);
  view_18.zbm(true);
  view_18.bb9(div(view_18.mba().jb0_1, 2));
  body(view_18, 'Work Groups');
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_19 = new (RowOrCol())(view_18.pc());
  var tmp0_elvis_lhs_19 = view_18.ebb_1;
  var p_19 = tmp0_elvis_lhs_19 == null ? view_18 : tmp0_elvis_lhs_19;
  view_18.gbb(p_19, view_19);
  view_19.zbm(true);
  view_19.bb9(get_px(0));
  forEachUpdating(view_19, cardinalChanges, VOID, ($this$forEachUpdating, change) => {
    renderReviewedChangeOrder(_this__u8e3s4, $this$forEachUpdating, change, getChangeRequestItems_0(_this__u8e3s4, change, changeOrderTables$lambda$lambda_1), true);
    return Unit_instance;
  });
  view_18.hbb(p_19, view_19);
  view_17.hbb(p_18, view_18);
  view_17.lbb(tmp_28, view_18);
  view_13.hbb(p_17, view_17);
  var tmp$ret$146 = view_13.lbb(tmp_25, view_17);
  view_13.lbb(tmp_24, tmp$ret$146);
  view_11.hbb(p_13, view_13);
  view.hbb(p_11, view_11);
  view.lbb(tmp_16, view_11);
  var voidedChangeOrders = remember(VOID, VOID, VOID, ($this$remember) => {
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = $this$remember.daj(_this__u8e3s4.kgt());
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList().w();
    var _iterator__ex2g4s = tmp0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      if (!(element.k72_1 == null)) {
        destination.v(element);
      }
    }
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList().u(collectionSizeOrDefault(destination, 10));
    var _iterator__ex2g4s_0 = destination.m1();
    while (_iterator__ex2g4s_0.n1()) {
      var item = _iterator__ex2g4s_0.o1();
      var tmp$ret$158 = item.c72_1;
      destination_0.v(tmp$ret$158);
    }
    var tmp = toSet(destination_0);
    // Inline function 'kotlin.collections.filter' call
    var tmp0_0 = $this$remember.daj(_this__u8e3s4.lgt());
    // Inline function 'kotlin.collections.filterTo' call
    var destination_1 = ArrayList().w();
    var _iterator__ex2g4s_1 = tmp0_0.m1();
    while (_iterator__ex2g4s_1.n1()) {
      var element_0 = _iterator__ex2g4s_1.o1();
      if (!(element_0.d76_1 == null)) {
        destination_1.v(element_0);
      }
    }
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_2 = ArrayList().u(collectionSizeOrDefault(destination_1, 10));
    var _iterator__ex2g4s_2 = destination_1.m1();
    while (_iterator__ex2g4s_2.n1()) {
      var item_0 = _iterator__ex2g4s_2.o1();
      var tmp$ret$164 = item_0.v75_1;
      destination_2.v(tmp$ret$164);
    }
    var voidedIds = plus_0(tmp, toSet(destination_2));
    // Inline function 'kotlin.collections.filter' call
    var tmp0_1 = $this$remember.daj(_this__u8e3s4.xgv());
    // Inline function 'kotlin.collections.filterTo' call
    var destination_3 = ArrayList().w();
    var _iterator__ex2g4s_3 = tmp0_1.m1();
    while (_iterator__ex2g4s_3.n1()) {
      var element_1 = _iterator__ex2g4s_3.o1();
      if (voidedIds.t1(element_1.o57_1)) {
        destination_3.v(element_1);
      }
    }
    return destination_3;
  });
  var tmp_29 = shownWhen(view, VOID, ($this$shownWhen) => {
    // Inline function 'kotlin.collections.isNotEmpty' call
    return !$this$shownWhen.daj(voidedChangeOrders).i1();
  });
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_20 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_20 = view.ebb_1;
  var p_20 = tmp0_elvis_lhs_20 == null ? view : tmp0_elvis_lhs_20;
  view.gbb(p_20, view_20);
  view_20.zbm(true);
  // Inline function 'com.crowpay.views.theming.subTitle' call
  var content_2 = 'Voided Changes';
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_21 = new (TextView())(view_20.pc());
  var tmp0_elvis_lhs_21 = view_20.ebb_1;
  var p_21 = tmp0_elvis_lhs_21 == null ? view_20 : tmp0_elvis_lhs_21;
  view_20.gbb(p_21, view_21);
  view_21.lba(view_21.qb6_1.abf(SubtitleSemantic_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var tmp_30 = view_21.vb5_1;
  var tmp_31;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(content_2) === 0) {
    tmp_31 = '\xA0';
  } else {
    tmp_31 = content_2;
  }
  tmp_30.hbu(tmp_31);
  view_20.hbb(p_21, view_21);
  // Inline function 'com.crowpay.views.components.sectionIndentCol' call
  // Inline function 'com.crowpay.views.components.indentedCol' call
  var indent_3 = Indent_Section_getInstance();
  var tmp2_3 = indent_3.agr_1;
  // Inline function 'com.crowpay.views.components.indentedCol' call
  var afterSpace_3 = indent_3.bgr_1;
  var tmp_32 = get_unpadded(view_20);
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_22 = new (Frame())(view_20.pc());
  var tmp0_elvis_lhs_22 = view_20.ebb_1;
  var p_22 = tmp0_elvis_lhs_22 == null ? view_20 : tmp0_elvis_lhs_22;
  view_20.gbb(p_22, view_22);
  var tmp_33;
  var tmp_34 = null;
  if (!((tmp_34 == null ? null : new (Dimension())(tmp_34)) == null)) {
    tmp_33 = sizeConstraints(view_22, VOID, VOID, VOID, VOID, VOID, null);
  } else {
    tmp_33 = Companion_getInstance();
  }
  var tmp_35 = view_22.kbb(tmp_33, indented(view_22, tmp2_3, afterSpace_3));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_23 = new (RowOrCol())(view_22.pc());
  var tmp0_elvis_lhs_23 = view_22.ebb_1;
  var p_23 = tmp0_elvis_lhs_23 == null ? view_22 : tmp0_elvis_lhs_23;
  view_22.gbb(p_23, view_23);
  view_23.zbm(true);
  view_23.bb9(get_px(0));
  var _iterator__ex2g4s = listOf([false, true]).m1();
  while (_iterator__ex2g4s.n1()) {
    var cardinal = _iterator__ex2g4s.o1();
    var tmp_36 = lensFilter(voidedChangeOrders, changeOrderTables$lambda_1(cardinal));
    forEachUpdating(view_23, tmp_36, VOID, changeOrderTables$lambda_2(_this__u8e3s4, cardinal));
  }
  view_22.hbb(p_23, view_23);
  view_22.lbb(tmp_35, view_23);
  view_20.hbb(p_22, view_22);
  view_20.lbb(tmp_32, view_22);
  view.hbb(p_20, view_20);
  view.lbb(tmp_29, view_20);
  var tmp_37 = shownWhen(view, VOID, ($this$shownWhen) => {
    var tmp;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!$this$shownWhen.daj(changeOrdersWithReviewedChanges).i1()) {
      tmp = true;
    } else {
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp = !$this$shownWhen.daj(voidedChangeOrders).i1();
    }
    return tmp;
  });
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_24 = new (Space())(view.pc(), 5.0);
  var tmp0_elvis_lhs_24 = view.ebb_1;
  var p_24 = tmp0_elvis_lhs_24 == null ? view : tmp0_elvis_lhs_24;
  view.gbb(p_24, view_24);
  view.hbb(p_24, view_24);
  view.lbb(tmp_37, view_24);
  writer.hbb(p, view);
  return view;
}
function changeOrderCards$_anonymous_$lensFilter_x2p6s4(_this__u8e3s4, predicate) {
  return lens(_this__u8e3s4, (it) => {
    // Inline function 'kotlin.collections.filter' call
    var predicate_0 = predicate;
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList().w();
    var _iterator__ex2g4s = it.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      if (predicate_0(element)) {
        destination.v(element);
      }
    }
    return destination;
  });
}
function getChangeRequestItems$lambda(it) {
  return true;
}
function getChangeRequestItems$lambda_0(it) {
  return it.z94() == null;
}
function getChangeRequestItems$lambda_1(it) {
  // Inline function 'kotlin.text.toFloat' call
  var this_0 = it.y94();
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return toDouble(this_0);
}
function getChangeRequestItems$lambda_2(it) {
  return true;
}
function Button$_get_enabled_$ref_61t7nx(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.vb5_1.bb4_1.kb7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.vb5_1.bb4_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.kb7_1.disabled = value;
    return Unit_instance;
  };
}
var projectChangeOrders$slambdaClass;
function projectChangeOrders$slambda() {
  if (projectChangeOrders$slambdaClass === VOID) {
    class $ {
      constructor($voiding) {
        this.zh9_1 = $voiding;
      }
      uao($completion) {
        toggle(this.zh9_1);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    projectChangeOrders$slambdaClass = $;
  }
  return projectChangeOrders$slambdaClass;
}
function projectChangeOrders$slambda_0($voiding) {
  var i = new (projectChangeOrders$slambda())($voiding);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function Button$_get_enabled_$ref_61t7nx_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.vb5_1.bb4_1.kb7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.vb5_1.bb4_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.kb7_1.disabled = value;
    return Unit_instance;
  };
}
function *_generator_invoke__zhh2q8($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var session = tmp;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.aha_1.lfy();
  var tmp_0 = await_0(this_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var proj = tmp_0.v7a_1;
  var tmp_1 = session.vfw().lff_1;
  // Inline function 'com.lightningkite.lightningdb.condition' call
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_2 = serializerOrContextual(createKType(getKClass(ChangeRequest()), arrayOf([]), false));
  var tmp$ret$2 = isInterface(tmp_2, KSerializer()) ? tmp_2 : THROW_CCE();
  // Inline function 'kotlin.let' call
  var it = new (DataClassPathSelf())(tmp$ret$2);
  var tmp$ret$6 = eq(get_project(it), proj);
  var tmp_3 = tmp_1.afi(tmp$ret$6, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  var new_0 = new (ChangeRequest())(VOID, proj, VOID, '', VOID, VOID, VOID, VOID, VOID, VOID, VOID, (tmp_3 + 1 | 0).toString());
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_2 = get_session();
  var tmp_4 = await_0(this_2, $completion);
  if (tmp_4 === get_COROUTINE_SUSPENDED())
    tmp_4 = yield tmp_4;
  var tmp_5 = tmp_4.jfv_1.lft(new_0, $completion);
  if (tmp_5 === get_COROUTINE_SUSPENDED())
    tmp_5 = yield tmp_5;
  get_mainPageNavigator($this.bha_1).fbw(new (ChangeOrderForm2())($this.aha_1.lf8(), new_0.o57_1, $this.aha_1));
  return Unit_instance;
}
var projectChangeOrders$slambdaClass_0;
function projectChangeOrders$slambda_1() {
  if (projectChangeOrders$slambdaClass_0 === VOID) {
    class $ {
      constructor($this_projectChangeOrders, $$this$button) {
        this.aha_1 = $this_projectChangeOrders;
        this.bha_1 = $$this$button;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    projectChangeOrders$slambdaClass_0 = $;
  }
  return projectChangeOrders$slambdaClass_0;
}
function projectChangeOrders$slambda_2($this_projectChangeOrders, $$this$button) {
  var i = new (projectChangeOrders$slambda_1())($this_projectChangeOrders, $$this$button);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
var sam$kotlin_Comparator$0Class;
function sam$kotlin_Comparator$0() {
  if (sam$kotlin_Comparator$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.cha_1 = function_0;
      }
      wi(a, b) {
        return this.cha_1(a, b);
      }
      compare(a, b) {
        return this.wi(a, b);
      }
      i4() {
        return this.cha_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i4(), other.i4());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i4());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class = $;
  }
  return sam$kotlin_Comparator$0Class;
}
function changeOrderCards$lambda$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.z57_1;
  var tmp$ret$1 = b.z57_1;
  return compareValues(tmp, tmp$ret$1);
}
function changeOrderCards$lambda(it) {
  return it.gh8_1.equals(Status_Draft_getInstance());
}
function changeOrderCards$lambda_0(it) {
  return setOf([Status_PendingApproval_getInstance(), Status_InReview_getInstance()]).t1(it.gh8_1);
}
function changeOrderCards$lambda_1(it) {
  return setOf([Status_PartiallyAccepted_getInstance(), Status_Accepted_getInstance(), Status_Rejected_getInstance()]).t1(it.gh8_1);
}
function RowOrCol$_get_shown_$ref_m8lfse(p0) {
  return () => p0.yb8();
}
function RowOrCol$_set_shown_$ref_7290m6(p0) {
  return (_this__u8e3s4) => {
    p0.jb7(_this__u8e3s4);
    return Unit_instance;
  };
}
var sam$kotlin_Comparator$0Class_0;
function sam$kotlin_Comparator$0_0() {
  if (sam$kotlin_Comparator$0Class_0 === VOID) {
    class $ {
      constructor(function_0) {
        this.dha_1 = function_0;
      }
      wi(a, b) {
        return this.dha_1(a, b);
      }
      compare(a, b) {
        return this.wi(a, b);
      }
      i4() {
        return this.dha_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i4(), other.i4());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i4());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class_0 = $;
  }
  return sam$kotlin_Comparator$0Class_0;
}
function changeOrderTables$lambda$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'kotlin.text.toFloatOrNull' call
  var this_0 = a.e26();
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp0_elvis_lhs = toDoubleOrNull(this_0);
  var tmp = tmp0_elvis_lhs == null ? a.e26() : tmp0_elvis_lhs;
  // Inline function 'kotlin.text.toFloatOrNull' call
  var this_1 = b.e26();
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp0_elvis_lhs_0 = toDoubleOrNull(this_1);
  var tmp$ret$7 = tmp0_elvis_lhs_0 == null ? b.e26() : tmp0_elvis_lhs_0;
  return compareValues(tmp, tmp$ret$7);
}
function changeOrderTables$lambda(it) {
  return !it.u57_1;
}
function changeOrderTables$lambda$lambda_0(it) {
  return !get_pending(it) && it.j95() == null;
}
function changeOrderTables$lambda_0(it) {
  return it.u57_1;
}
function changeOrderTables$lambda$lambda_1(it) {
  return !get_pending(it) && it.j95() == null;
}
function changeOrderTables$lambda_1($cardinal) {
  return (it) => it.u57_1 === $cardinal;
}
function changeOrderTables$lambda$lambda_2(it) {
  return !(it.j95() == null);
}
function changeOrderTables$lambda_2($this_changeOrderTables, $cardinal) {
  return ($this$forEachUpdating, change) => {
    renderReviewedChangeOrder($this_changeOrderTables, $this$forEachUpdating, change, getChangeRequestItems_0($this_changeOrderTables, change, changeOrderTables$lambda$lambda_2), $cardinal);
    return Unit_instance;
  };
}
//region block: exports
export {
  projectChangeOrders as projectChangeOrders19dwzo9rdck4z,
};
//endregion

//# sourceMappingURL=projectChangeOrders.mjs.map
